import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu {
    model: any[] = [];

    ngOnInit() {
        this.model = [
            {
                label: 'Principal',
                icon: 'pi pi-home',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/dashboard']
                    },
                    // {
                    //     label: 'Calendario',
                    //     icon: 'pi pi-fw pi-calendar',
                    //     routerLink: ['/calendario']
                    // },
                    {
                        label: 'Mis Reservas',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['/mis-reservas']
                    }
                ]
            },
            {
                label: 'Usuario',
                icon: 'pi pi-user',
                items: [
                    {
                        label: 'Perfil',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/perfil']
                    }
                ]
            }
        ];
    }
}
